import VueGtag, { useGtag } from 'vue-gtag-next';

export default defineNuxtPlugin( ( nuxtApp ) => {

    const { event } = useGtag();

    if ( import.meta.client ) {
        
        let id = window.location.hostname.includes("gamania.com") ? "G-HNKFPFZ5NX" : "G-K4LJCGE6T3";
        
        nuxtApp.vueApp.use( VueGtag, {
            property: {
                id,
                params: {
                    send_page_view: true,
                },
            },
        } );
        
    }
    nuxtApp.vueApp.directive( 'sendGAsignal', {

        mounted ( el, binding ) {

            let { event_category, event_label } = binding.value || {};
            el.onclick = () => {
                event( "click", { event_category, event_label } );
            };

        },

        updated ( el, binding ) {

            let { event_category, event_label } = binding.value || {};
            el.onclick = () => {
                event( "click", { event_category, event_label } );
            };

        },

    } );

} );
